export default ({ items = [], currentVideoId }) => {
  const currentIndex = items.findIndex((item) => item.id === Number(currentVideoId));
  if (currentIndex === -1) return null;

  const nextIndex = currentIndex + 1;
  const nextItem = items[nextIndex];
  return nextItem ?? null;
};
